import { getQueryObject } from '@/utils'

// iframe 嵌入事件标识
export const X_SOURCE_WINDOW = "__my_source_window__"
/************* iframe 需要参数 **************/
export const X_BLOCK = "__my_block__"   // 是否阻止
export const X_ID = "__my_id__"         // 区分不同iframe
export const X_ORI_DATA = "__my_ori_data__"
export const X_PRODUCT = "__my_product__"   // 区分产品线
export const X_HIDE = "hide"
export const X_tabCardNum = 'tabCardNum'
export const X_smallCardNum = 'smallCardNum'
export const X_isQw = 'isQw' //区分企微版 还是专业版

/************* iframe send message 类型 **************/
export const MODE_MOUNTED = "mounted"       // 载入事件
export const MODE_CLICK = "click"           // 点击事件
export const MODE_LINK = "link"           // 点击事件
export const MODE_CODE = "code"           // 点击事件

/************* iframe receive message 类型 **************/
export const MODE_ORI_DATA = "oriData"           // 元数据
export const MODE_UNLOCK = "unlock"              // 未解锁状态变更  data {name, hid} 

const linkMap = {
    "1": { linkType: "1", linkName: "首页", link: "/zxk/home" },
    "2": { linkType: "2", linkName: "企业查询", link: "/zxk/search/index" },
    "2-1": { linkType: "2-1", linkName: "企业列表", link: "/zxk/search/clueList" },
    "3": { linkType: "3", linkName: "新企查询", link: "/zxk/search/newlyCompany" },
    "4": { linkType: "4", linkName: "招标查询", link: "/zxk/search/biddingInquiry" },
    "5": { linkType: "5", linkName: "批量查询", link: "/zxk/search/batchSearch" },
    "6": { linkType: "6", linkName: "高级搜索", link: "/zxk/junbros/advancedSearch" },
    "7": { linkType: "7", linkName: "商机地图", link: "/zxk/junbros/map" },
    "8": { linkType: "8", linkName: "智能推荐", link: "/zxk/junbros/intelRecommend" },
    "9": { linkType: "9", linkName: "匿名访客", link: "/zxk/junbros/getCustomers" },
    "10": { linkType: "10", linkName: "产业链路", link: "/zxk/junbros/industryChain" },
    "11": { linkType: "11", linkName: "解锁列表", link: "/zxk/talkManage/unlockList" },
    "12": { linkType: "12", linkName: "我的收藏", link: "/zxk/talkManage/myAttention" },
    "13": { linkType: "13", linkName: "商机订阅", link: "/zxk/junbros/subscribeList" },
    "14": { linkType: "14", linkName: "号码清洗", link: "/zxk/junbros/numberCleaningList" }
}


window[X_SOURCE_WINDOW] = window.parent

function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

export function resetIframeParams() {
    const paramBlock = getQueryObject()[X_BLOCK]
    if (paramBlock && paramBlock == "true") {
        window[X_BLOCK] = true
    }

    const paramID = getQueryObject()[X_ID]
    if (paramID) {
        window[X_ID] = paramID
    }

    const paramHide = getQueryObject()[X_HIDE]
    if (paramHide && paramHide == "true") {
        window[X_HIDE] = true
    }

    const paramtabCardNum = getQueryObject()[X_tabCardNum]
    if (paramtabCardNum) {
        window[X_tabCardNum] = paramtabCardNum
    }

    const paramsmallCardNum = getQueryObject()[X_smallCardNum]
    if (paramsmallCardNum || paramsmallCardNum == 0) {
        window[X_smallCardNum] = paramsmallCardNum
    }

    const paramisQw = getQueryObject()[X_isQw]
    if (paramisQw) {
        window[X_isQw] = paramisQw
    };

    (function () {
        if (!window[X_BLOCK]) {
            var tm = document.createElement("script");
            tm.src = process.env.VUE_APP_T_FORCE_URL;
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(tm, s);
        }
    })();
}
function sendIframeMountedMessage(data) {
    data = data || {}
    window[X_SOURCE_WINDOW].postMessage({
        mode: MODE_MOUNTED,
        id: window[X_ID],
        info: data
    }, '*')
}

export function sendIframeMessage(data) {
    if (!window[X_BLOCK]) return false
    data = data || {}
    window[X_SOURCE_WINDOW].postMessage({
        mode: MODE_CLICK,
        id: window[X_ID],
        info: data,
        raw: window[X_ORI_DATA]
    }, '*')
    return true
}

export function sendIframeLinkMessage(data) {
    if (!window[X_BLOCK]) return false
    data = data || {}
    const { query, type } = data
    const typeData = linkMap[type] || {}
    window[X_SOURCE_WINDOW].postMessage({
        mode: MODE_LINK,
        id: window[X_ID],
        info: {
            ...typeData,
            query: query || {}
        },
        raw: window[X_ORI_DATA]
    }, '*')
    return true
}

export function sendIframeCodeMessage(data) {
    if (!window[X_BLOCK]) return false
    window[X_SOURCE_WINDOW].postMessage({
        mode: MODE_CODE,
        id: window[X_ID],
        info: data,
        raw: window[X_ORI_DATA]
    }, '*')
    return true
}

//当 A 页面 postMessage 被调用后，这个 function 被 addEventListener 调用
function receiveMessage(event) {
    // 我们能信任信息来源吗？
    // if (event.origin !== "http://example.com:8080")
    //     return;

    // event.source 就当前弹出页的来源页面
    // event.data 是 "hello there!"

    // 假设你已经验证了所受到信息的 origin (任何时候你都应该这样做), 一个很方便的方式就是把 event.source
    // 作为回信的对象，并且把 event.origin 作为 targetOrigin
    const { data } = event || {}
    if (!isObject(data)) return
    const { mode } = data || {}
    if (mode == MODE_ORI_DATA) {
        window[X_ORI_DATA] = data.data || {}
    } else if (mode == MODE_UNLOCK) {
        console.log(data.data)
        $bus.$emit('iframe-unlock', data.data || {})
    }
}

export function initIframe() {
    if (!window[X_BLOCK]) return
    if (!window[X_SOURCE_WINDOW]) {
        return console.log('iframe 载入失败')
    }
    console.log('iframe 载入中')
    sendIframeMountedMessage()
    window.addEventListener("message", receiveMessage, false);
}


window.__sendIframeMessage = sendIframeMessage
window.__sendIframeLinkMessage = sendIframeLinkMessage
window.__sendIframeCodeMessage = sendIframeCodeMessage

